import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, Empty, Row, Space } from 'antd';
import { useUIDispatchContext } from 'providers/UI';
import { Link, useParams } from 'react-router-dom';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { useAppointmentDetails } from 'providers/AppointmentDetails';

import { StyledEmptyCard } from './styled';
import { ReportCard, ReportFileCard } from 'components/shared';

const Reports: FC = () => {
  const { t } = useTranslation();
  const params = useParams();
  const { toggleModal } = useUIDispatchContext();

  // the detail appointment already carries report + reports_file (via the
  // #10/#18 joins), so read it straight from the context
  const { appointment } = useAppointmentDetails();

  if (appointment?.report) {
    return (
      <Row>
        <Col span={12}>
          <ReportCard
            id={appointment.report.id}
            appointmentId={params.id || ''}
            dateReport={appointment.report.date_report}
            report={appointment.report.report}
            status={appointment.report.status}
          />
        </Col>
      </Row>
    );
  }

  if (appointment?.reports_file) {
    return (
      <Row>
        <Col span={12}>
          <ReportFileCard
            id={appointment.reports_file.id}
            date={appointment.reports_file.created_at}
            file={appointment.reports_file.file}
            note={appointment.reports_file.note}
          />
        </Col>
      </Row>
    );
  }

  return (
    <StyledEmptyCard>
      <Empty
        imageStyle={{
          height: 60
        }}
        description={<span>{t('appointments_details.no_report')}</span>}
      >
        <Space size={16}>
          <Button
            type="primary"
            ghost
            onClick={() =>
              toggleModal('appointmentReport', true, {
                id: params.id as string
              })
            }
          >
            <UploadOutlined />
            {t('reports.upload_report')}
          </Button>
          <div>
            <Link to={`/report/details?id=${params.id}`}>
              <Button type="primary">
                <PlusOutlined />
                {t('appointments_details.add_report')}
              </Button>
            </Link>
          </div>
        </Space>
      </Empty>
    </StyledEmptyCard>
  );
};

export default Reports;
